import { MessageType, MessageMsgFrom } from '@tencent/dz-models';
import { ImpCoreModel } from './ImpCoreMode';
import { logger } from 'src/helper';
import { formatMessageEntities } from 'src/utils';

export class ImpChatBotModel {
  coreModel: ImpCoreModel;

  constructor(coreModel: ImpCoreModel) {
    this.coreModel = coreModel;
  }

  public async getChatBotHistoryMsg() {
    const messageModel = this.coreModel.getMessageModel();
    const consultModel = this.coreModel.getConsultModel();
    const consultConfig = consultModel.getConsultConfig();

    const url = consultModel.hitTheGray ? '/viewer/consult/get_snapshot_info' : '/custom/consult/get_snapshot_info';
    const response = await this.coreModel.request.get(url, {
      params: {
        u_id: consultModel.uid,
        consult_id: consultConfig.consult_id,
        snapshot_token: consultModel.snapshotToken,
      },
    });
    if (response.code !== 0) return logger.error('get_snapshot_info error', response);

    const { data } = response;
    const historyMsgData = formatMessageEntities(data.msg_list);
    // 推送消息
    messageModel.pushMessage([{
      type: MessageType.SystemHistory,
      msg_from: MessageMsgFrom.Server,
      payload: {
        message: '智能客服历史消息',
      },
    }, ...historyMsgData]);
  }
}
